var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Form } from "radix-ui";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import client from "../../http/client";
import { RadixInput } from "../primitives/RadixInput";
import { RadixButton } from "../primitives/RadixButton";
import { useDebouncedValidation } from "../utility/useDebouncedValidation";
import { resetPasswordFormSchema } from "./resetPasswordFormSchema";
import "../ui.css";
import "./resetPasswordForm.css";
export var ResetPasswordForm = function () {
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useState(null), submitError = _b[0], setSubmitError = _b[1];
    var _c = useForm({
        resolver: zodResolver(resetPasswordFormSchema),
        mode: "onSubmit",
        defaultValues: {
            password: "",
            confirmPassword: "",
        },
    }), control = _c.control, handleSubmit = _c.handleSubmit, trigger = _c.trigger, _d = _c.formState, errors = _d.errors, isValid = _d.isValid;
    var debouncedTrigger = useDebouncedValidation(trigger);
    var handleValidSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, errorResponse;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setSubmitError(null);
                    setIsSubmitting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client.post("/reset-password", {
                            password: values.password,
                            password2: values.confirmPassword,
                            token: window.passwordResetToken,
                        })];
                case 2:
                    _c.sent();
                    window.location.assign(window.relativeURI());
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    errorResponse = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data;
                    setSubmitError(((_b = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.friendly) === null || _b === void 0 ? void 0 : _b.description) || (errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.message) || "Unable to reset your password. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("section", { className: "reset-password-form", "aria-label": "Reset password form" },
        React.createElement("h1", { className: "reset-password-form__title" }, "Set a new password"),
        React.createElement("p", { className: "reset-password-form__description" }, "Enter your new password and confirm it to finish resetting your account password."),
        React.createElement(Form.Root, { onSubmit: handleSubmit(handleValidSubmit), className: "radix-form", noValidate: true },
            React.createElement("div", { className: "radix-form-field" },
                React.createElement("label", { className: "reset-password-form__label", htmlFor: "reset-password-form-password" }, "New password"),
                React.createElement(Controller, { name: "password", control: control, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RadixInput, { id: "reset-password-form-password", name: "password", type: "password", autoComplete: "new-password", value: field.value, onChange: function (event) {
                                field.onChange(event.target.value);
                                debouncedTrigger("password");
                            }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.password, "aria-describedby": errors.password ? "reset-password-form-password-error" : "reset-password-form-password-help" }));
                    } }),
                React.createElement("span", { id: "reset-password-form-password-help", className: "reset-password-form__help-text" }, "Use at least 8 characters, including 1 uppercase letter, 1 number, and 1 special character. Only standard letters, numbers, and symbols are allowed."),
                errors.password ? React.createElement("span", { id: "reset-password-form-password-error", className: "radix-error-message" }, errors.password.message) : null),
            React.createElement("div", { className: "radix-form-field" },
                React.createElement("label", { className: "reset-password-form__label", htmlFor: "reset-password-form-confirm-password" }, "Confirm new password"),
                React.createElement(Controller, { name: "confirmPassword", control: control, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RadixInput, { id: "reset-password-form-confirm-password", name: "confirmPassword", type: "password", autoComplete: "new-password", value: field.value, onChange: function (event) {
                                field.onChange(event.target.value);
                                debouncedTrigger("confirmPassword");
                            }, onBlur: field.onBlur, ref: field.ref, "aria-invalid": !!errors.confirmPassword, "aria-describedby": errors.confirmPassword ? "reset-password-form-confirm-password-error" : undefined }));
                    } }),
                errors.confirmPassword ? React.createElement("span", { id: "reset-password-form-confirm-password-error", className: "radix-error-message" }, errors.confirmPassword.message) : null),
            submitError ? (React.createElement("span", { className: "radix-error-message", role: "alert" }, submitError)) : null,
            React.createElement(RadixButton, { type: "submit", disabled: !isValid || isSubmitting, className: "radix-submit-button", "aria-busy": isSubmitting }, isSubmitting ? "Updating password..." : "Update password"))));
};
